import React from 'react';
import { Archive } from 'lucide-react';
import { ArchivedClientsList } from './ArchivedClientsList';
import { useClients } from '../../hooks/useClients';
import { Counter } from '../../components/ui/Counter';

export const ArchivedClients: React.FC = () => {
  const { clients, isLoading } = useClients();
  const archivedClients = clients.filter(client => client.status === 'archived');

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8 flex items-center gap-4">
          <div className="flex items-center gap-3">
            <Archive className="h-8 w-8 text-primary-500" />
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              Clients archivés
            </h1>
          </div>
          <Counter 
            count={archivedClients.length} 
            label={archivedClients.length > 1 ? "clients archivés" : "client archivé"}
            variant="default"
          />
        </div>

        {isLoading ? (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className="h-[200px] animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700"
              />
            ))}
          </div>
        ) : (
          <ArchivedClientsList clients={archivedClients} />
        )}
      </div>
    </div>
  );
};